import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(private authService: AuthService, private router: Router) { }

  /**
   * Determines if a route can be activated.
   * @param route The activated route snapshot.
   * @param state The router state snapshot.
   * @returns An Observable, Promise, or boolean indicating whether the route can be activated.
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    // FUNCTION GUARD - FAIL FIRST
    if (!this.authService.isLoggedIn()) {
      console.warn('Access denied: User not authenticated. Redirecting to login.');
      return this.router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
    }

    // 2. Check for required roles if specified in route data
    // Get the role from route data:  data: { requiredRole: 'admin' }
    const requiredRole = route.data['requiredRole'] as string;

    // FUNCTION GUARD - FAIL FIRST
    if (requiredRole == 'admin' && !this.authService.isAdmin()) {
      console.warn(`Access denied: User does not have the required role: ${requiredRole}.`);
      // Optionally redirect to an unauthorized page or home
      return this.router.createUrlTree(['/home']); // Redirect to home if unauthorized
    }

    // FUNCTION GUARD - FAIL FIRST
    if (requiredRole == 'assistant' && !this.authService.isAssistant()) {
      console.warn(`Access denied: User does not have the required role: ${requiredRole}.`);
      // Optionally redirect to an unauthorized page or home
      return this.router.createUrlTree(['/home']); // Redirect to home if unauthorized
    }

    // User is authenticated and has the required role (if any)
    return true;
  }

}